import React from 'react';
import Icon from '../../../components/AppIcon';

const NutritionInsights = ({ insights }) => {
  const insightIcons = {
    success: { name: 'CheckCircle2', color: 'var(--color-success)' },
    warning: { name: 'AlertTriangle', color: 'var(--color-warning)' },
    info: { name: 'Info', color: 'var(--color-primary)' },
    tip: { name: 'Lightbulb', color: 'var(--color-accent)' }
  };

  const insightStyles = {
    success: 'bg-success/10 border-success/20',
    warning: 'bg-warning/10 border-warning/20',
    info: 'bg-primary/10 border-primary/20',
    tip: 'bg-accent/10 border-accent/20'
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Sparkles" size={20} color="var(--color-accent)" />
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
          Personalized Insights
        </h3>
      </div>
      <div className="space-y-4">
        {insights?.map((insight) => {
          const icon = insightIcons?.[insight?.type];
          const style = insightStyles?.[insight?.type];
          
          return (
            <div 
              key={insight?.id}
              className={`p-4 border rounded-lg ${style}`}
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-0.5">
                  <Icon 
                    name={icon?.name} 
                    size={20} 
                    color={icon?.color}
                    strokeWidth={2}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base font-medium text-foreground mb-1">
                    {insight?.title}
                  </p>
                  <p className="text-xs md:text-sm caption text-muted-foreground">
                    {insight?.description}
                  </p>
                  {insight?.action && (
                    <button 
                      onClick={() => {}}
                      className="mt-2 text-xs md:text-sm font-medium text-primary hover:underline"
                    >
                      {insight?.action}
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Icon name="Target" size={18} color="var(--color-primary)" />
            <span className="text-sm md:text-base font-medium text-foreground">
              Goal Progress
            </span>
          </div>
          <span className="text-sm md:text-base font-semibold data-text text-success">
            78% Complete
          </span>
        </div>
        <div className="relative h-2 bg-muted rounded-full overflow-hidden mt-3">
          <div 
            className="absolute top-0 left-0 h-full bg-success rounded-full transition-smooth"
            style={{ width: '78%' }}
          />
        </div>
        <p className="text-xs caption text-muted-foreground mt-2">
          Keep up the great work! You're on track to reach your nutrition goals.
        </p>
      </div>
    </div>
  );
};

export default NutritionInsights;